export function Filter({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.33334 14.6663V9.99967M4.33334 3.33301V1.33301M11.6667 14.6663V12.6663M11.6667 5.99967V1.33301M6.33334 4.66634V8.66634C6.33334 9.39967 6.00001 9.99967 5.00001 9.99967H3.66668C2.66668 9.99967 2.33334 9.39967 2.33334 8.66634V4.66634C2.33334 3.93301 2.66668 3.33301 3.66668 3.33301H5.00001C6.00001 3.33301 6.33334 3.93301 6.33334 4.66634ZM13.6667 7.33301V11.333C13.6667 12.0663 13.3333 12.6663 12.3333 12.6663H11C10 12.6663 9.66668 12.0663 9.66668 11.333V7.33301C9.66668 6.59967 10 5.99967 11 5.99967H12.3333C13.3333 5.99967 13.6667 6.59967 13.6667 7.33301Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
